import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Wheel features',
  name: 'wheelFeatures',
  type: 'object',
  fields: [
    defineField({
      name: 'heading',
      type: 'string',
      description: 'If added shows a red hero block above feature list',
    }),
    defineField({
      name: 'features',
      type: 'array',
      of: [{ type: 'feature' }],
    }),
  ],
  preview: {
    select: {
      features: 'features',
    },
    prepare({ features }) {
      const count = features?.length || 0
      return {
        title: `${count} features`,
        subtitle: 'Wheel features',
      }
    },
  },
})